import '../../global.css';

export const About = () => {
    return (
        <div style={{ margin:"20px", width:"55%" }}>
            <p>
                hiya, welcome to my website! <span className="wave">👋</span>
            </p>
            <p>
                i'm nareh, an aspiring software developer based in los angeles. i'm currently pursuing my bachelor's in computer science at ucla. outside of studies, i spend my time as co-president of acm hack at ucla, a computer science organization focused on empowering the community by exploring what's possible through code.
            </p>
            <p>
                i do enjoy creating projects in my free time (this website is a result of that!), but outside of programming, i'm particularly interested in music (listening, playing, production, theory), playing video games with buddies, and (more recently) reading!
            </p>
            <p>
                for contact beyond my <a href="https://github.com/nareha">github</a> or <a href="https://www.linkedin.com/in/nareha/">linkedin</a>, feel free to shoot me an <a href="mailto:nareh.agazaryan@gmail.com">email</a>!
            </p>
        </div>
    );
};
